import React from 'react';
import { Header } from '../Layouts/Header';
import '../../styles/homepage.css';
import '../../styles/otherpage.css';
import location from '../../assets/imgs/locations.svg';
import Footer from '../Layouts/Footer';
import CallToActionButton from '../Layouts/CallToActionButton';

export const LocationsPage = () => {
  return (
    <div className='home-container'>
      <header className='header-container'>
        <Header action='/download' />
        <div className='hero-container'>
          <div className='intro'>
            <h1>
              <span>Is LionTaxi In My City?</span>
            </h1>
            <h3>LionTaxi Locations</h3>
            <div className='store-buttons'>
              <CallToActionButton store={true} />
            </div>
          </div>
          <div className='svg-content'>
            <img src={location} width={550} height={438} alt='app screenshot' />
          </div>
        </div>
      </header>
      <main className='home-main'>
        <p>This page is under construction</p>
      </main>
      <Footer />
    </div>
  );
};
